export const downloadFile = async (presignedUrl: string, fileName: string) => {
  // The `download` attribute is ignored for cross-origin URLs (e.g. presigned S3 URLs).
  // Fetching as a blob creates a same-origin URL where `download` is honored.
  // However, Safari ignores `download` on blob URLs and loses the user-gesture
  // context after async operations — fall back to direct navigation for Safari.
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isSafari) {
    const link = document.createElement('a');
    link.href = presignedUrl;
    link.download = fileName;
    link.target = '_blank';
    link.click();
    return;
  }

  let blobUrl: string | undefined;

  try {
    const response = await fetch(presignedUrl);

    if (!response.ok) {
      throw new Error(
        `Failed to download file: ${response.status} ${response.statusText}`
      );
    }

    const blob = await response.blob();
    blobUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    link.click();

    setTimeout(() => {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    }, 1000);
  } catch (error) {
    if (blobUrl) URL.revokeObjectURL(blobUrl);
    throw error;
  }
};
